class CookieConsent extends HTMLElement {
	constructor() {
		super();  

        this.cookie = this;

		if (this.getCookie('cookie-consent') === ''){
            this.cookie.style.display = "block";

            this.originalBodyPadding = document.body.style.paddingBottom;
            this.updatePageSpace = () => {
                const needsSpace = this.cookie.classList.contains('full-width') ||
                    window.matchMedia('(max-width: 767px)').matches;
                document.body.style.paddingBottom = needsSpace
                    ? (this.cookie.getBoundingClientRect().height + 24) + 'px'
                    : this.originalBodyPadding;
            };
            this.updatePageSpace();
            this.sizeObserver = new ResizeObserver(this.updatePageSpace);
            this.sizeObserver.observe(this.cookie);
            window.addEventListener('resize', this.updatePageSpace);

		} else {
			this.remove();
		}

		this.querySelector('[data-accept-cookie]').addEventListener(
            'click',
            this.setClosePopup.bind(this)
        );
	}

	setCookie(cname, cvalue) {
        document.cookie = cname + '=' + cvalue + ';path=/';
    }

	getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        
        return '';
    }

    deleteCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    setClosePopup(event) {
        event.preventDefault();
        
        this.setCookie('cookie-consent', 'closed');
        this.cookie.remove();

        if (this.sizeObserver) this.sizeObserver.disconnect();
        if (this.updatePageSpace) window.removeEventListener('resize', this.updatePageSpace);
        document.body.style.paddingBottom = this.originalBodyPadding || "";

    }
}

customElements.define('cookie-consent', CookieConsent);